export default __webpack_public_path__ + "static/media/Enten-beim-Entenhaus.54f94111.webp";